import { Controller } from 'react-hook-form';
import { NavLink } from 'react-router-dom';
import { Autocomplete, IconArrowRight, InputText, Select } from '@ui/src';
import { ExternalAccountFormRowTypes } from './types';

import cn from './styles.module.css';

const ExternalAccountFormRow = ({
  accountId,
  inputValue,
  type,
  inputName,
  list,
  control,
  setSelectedPartner,
  error,
  setValue,
  title,
  placeholder,
  onClear,
  listIsLoading,
  onSearchList,
  setSelectedPaymentType,
  disabled,
  pspPartners,
  filteredPaymentTypes,
  link,
  withSuffix,
  withClearButton,
  setIsOpenPayd,
  setIsPrimeVault,
  setIsKeel,
}: ExternalAccountFormRowTypes) => {
  let content;

  if (accountId) {
    content = (
      <div className={cn.infoBlockRow}>
        <div className={cn.infoBlockRowTitle}>{title}</div>
        <div className={cn.infoBlockRowValue}>
          {link ? (
            <NavLink to={link} target="_blank" className={cn.infoBlockRowLink}>
              {inputValue}
              <IconArrowRight width={12} height={12} />
            </NavLink>
          ) : (
            inputValue
          )}
        </div>
      </div>
    );
  } else {
    content = (
      <div className={cn.formValues}>
        {type === 'select' && (
          <Controller
            control={control}
            defaultValue=""
            name={inputName}
            render={({ field: { value, name, onChange } }) => (
              <Select
                name={name}
                value={value as string}
                title={title}
                placeholder={placeholder}
                list={list}
                onChange={(e) => {
                  onChange(e);

                  if (setSelectedPartner && pspPartners) {
                    if (e.target.value) {
                      const currentPartner = pspPartners?.find(
                        (item) => item.id === e.target.value,
                      );

                      if (currentPartner) {
                        setSelectedPartner(currentPartner);
                      }
                    } else {
                      setSelectedPartner(undefined);

                      if (setIsOpenPayd) {
                        setIsOpenPayd(false);
                      }

                      if (setIsPrimeVault) {
                        setIsPrimeVault(false);
                      }

                      if (setIsKeel) {
                        setIsKeel(false);
                      }
                    }

                    if (setValue) {
                      setValue('paymentType', '');
                    }
                  }

                  if (setSelectedPaymentType && filteredPaymentTypes) {
                    const currentPaymentType = filteredPaymentTypes?.find(
                      (item) => item.paymentType === e.target.value,
                    );

                    if (currentPaymentType) {
                      setSelectedPaymentType(currentPaymentType);
                    }
                  }
                }}
                error={error}
                disabled={disabled}
                withClearButton={withClearButton}
                fullWidth
              />
            )}
          />
        )}
        {type === 'autocomplete' && (
          <Controller
            control={control}
            defaultValue=""
            name={inputName}
            render={({ field: { value, name, onChange } }) => (
              <Autocomplete
                name={name}
                value={value as string}
                title={title}
                placeholder={placeholder}
                list={list}
                onChange={(e) => {
                  onChange(e);

                  if (!e.target.value && onClear) {
                    onClear();
                  }
                }}
                isLoading={listIsLoading}
                onSearch={(search) => onSearchList && onSearchList(search)}
                error={error}
                withSuffix={withSuffix}
                withCopySuffix={withSuffix}
                withClearButton
                fullWidth
              />
            )}
          />
        )}
        {type === 'text' && (
          <Controller
            control={control}
            defaultValue=""
            name={inputName}
            render={({ field: { value, name, onChange } }) => (
              <InputText
                name={name}
                value={value as string}
                title={title}
                placeholder={placeholder || ''}
                onChange={onChange}
                error={error}
              />
            )}
          />
        )}
      </div>
    );
  }

  return content;
};

export default ExternalAccountFormRow;
